const initialData = {
  // measures: [
  //   {id: 'measure1', content: 'Longitude'},
  //   {id: 'measure2', content: 'Latitude'},
  //   {id: 'measure3', content: 'Population'},
  //   {id: 'measure4', content: 'Mobile usage'},
  // ],
  columns: {
    measures: {
      id: 'measures',
      title: 'Fields',
      type: 'measures',
      measures: []
      //measures: ['measure1', 'measure2', 'measure3', 'measure4']
    },
    config_options: {
      id: 'config_options',
      title: 'Network Fields',
      type: 'options',
      areaIds: ['ConfigSourceField', 'ConfigTargetField', 'ConfigSourceColorField', 'ConfigTargetColorField', 'ConfigValueField']
    }
  },
  drop_area: {
    ConfigSourceField: {
      id: 'ConfigSourceField',
      title: 'Source',
      type: 'single_drop',
      icon: 'SourceIcon',
      measureId: null, 
      required: true
    },
    ConfigTargetField: {
      id: 'ConfigTargetField',
      title: 'Target',
      type: 'single_drop',
      icon: 'TargetIcon',
      measureId: null, 
      required: true
    },
    ConfigSourceColorField: {
      id: 'ConfigSourceColorField',
      title: 'Color Source By',
      type: 'single_drop',
      icon: 'FillByIcon',
      measureId: null, 
      required: false
    },
    ConfigTargetColorField: {
      id: 'ConfigTargetColorField',
      title: 'Color Target By',
      type: 'single_drop',
      icon: 'FillByIcon',
      measureId: null, 
      required: false
    },
    ConfigValueField: {
      id: 'ConfigValueField',
      title: 'Size by',
      type: 'single_drop',
      icon: 'SizeByIcon',
      measureId: null, 
      required: false
    },
  },
  columnOrder: ['measures', 'config_options']
}

export default initialData;


// WEBPACK FOOTER //
// ./src/components/DragNDrop/initial-data.js